import {Injectable} from '@angular/core';
import {teamStore} from './team.store';
import {ITeamMemberResponse, IUnitDto} from '../../models/interfaces';
import {TeamMembership} from '../../../types/team-management.type';
import {setProps} from '@ngneat/elf';
import {ManageGroupDto, TeamMemberDto, UnitDto} from '../../../../userway/sdk/SSOApiClient';

@Injectable({providedIn: 'root'})
export class TeamManager {
  setTeamData(data: IUnitDto) {
    teamStore.update(state => ({
      ...state,
      teamData: {
        ...state.teamData,
        ...data,
      },
      filteredTeamMembers: data.teamMembers.teamMembers,
    }));
  }

  setTeamUnits(teamUnits: UnitDto[]) {
    teamStore.update(setProps({teamUnits}));
  }

  setCurrentTeamUnit(currentTeamUnit: UnitDto) {
    teamStore.update(setProps({currentTeamUnit}));
  }

  setUserMemberships(userMemberships: TeamMembership[]) {
    teamStore.update(setProps({userMemberships}));
  }

  updateTeamData(data: Partial<IUnitDto>) {
    teamStore.update(state => ({
      ...state,
      teamData: {
        ...state.teamData,
        name: data.name || state.teamData.name,
        teamMembersCount: data.teamMembersCount || state.teamData.teamMembersCount,
        teamMembers: {
          ...state.teamData.teamMembers,
          teamImageUrl: data?.teamMembers?.teamImageUrl || state.teamData.teamMembers.teamImageUrl,
        } as ITeamMemberResponse,
        ...data,
      },
    }));
  }

  setFilteredTeamMembers(filteredTeamMembers: TeamMemberDto[]) {
    teamStore.update(setProps({filteredTeamMembers}));
  }

  updateFilteredTeamMember(member: TeamMemberDto) {
    teamStore.update(state => {
      const filteredTeamMembers = state.filteredTeamMembers.map(filteredMember => {
        if (filteredMember.memberId === member.memberId) {
          return member;
        } else {
          return filteredMember;
        }
      });

      return {
        ...state,
        filteredTeamMembers,
      };
    });
  }

  setGroups(groups: ManageGroupDto[]) {
    teamStore.update(setProps({groups, filteredGroups: groups}));
  }

  setFilteredGroups(filteredGroups: ManageGroupDto[]) {
    teamStore.update(setProps({filteredGroups}));
  }

  setCurrentGroup(currentGroup: ManageGroupDto) {
    teamStore.update(setProps({currentGroup}));
  }

  reset() {
    teamStore.reset();
  }
}
